import type { Questionnaire } from '@medplum/fhirtypes'

export const editTaskDueDateQuestionnaire = {
  resourceType: 'Questionnaire',
  status: 'active',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/task-change-due-date',
  id: 'task-change-due-date',
  title: 'Change Due Date',
  item: [
    {
      linkId: 'dueDate',
      text: 'Due Date',
      type: 'date',
      required: true,
    },
  ] as const,
} satisfies Questionnaire
